import styled, { css } from 'styled-components'

export const PropertyTagsContainer = styled.div`
  position: relative;
`

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  cursor: pointer;
  padding: 4px;
  margin: -4px;
  border-radius: 8px;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.02);
  }
`

export const EmptyStateContainer = styled.div`
  display: inline-block;
`

export const PropertyTag = styled.button.attrs({ type: 'button' })<{
  $color: string
  $isPrimary?: boolean
}>`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  height: 24px;
  gap: 4px;
  margin: 0;
  padding: 0 10px;
  border: none;
  border-radius: 6px;
  font-family: inherit;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;

  ${({ $isPrimary }) =>
    $isPrimary &&
    css`
      padding-right: 8px;
      font-weight: 600;
    `}

  color: ${({ $color }) => ($color && $color.trim() !== '' ? $color : '#374151')};

  background: ${({ $color, $isPrimary }) => {
    if (!$color || $color.trim() === '') return '#e5e7eb'

    // Convert hex to RGB for gradient
    const hex = $color.replace('#', '')
    const r = parseInt(hex.substr(0, 2), 16)
    const g = parseInt(hex.substr(2, 2), 16)
    const b = parseInt(hex.substr(4, 2), 16)

    // Slightly more opaque for primary tags
    const opacity1 = $isPrimary ? 0.15 : 0.1
    const opacity2 = $isPrimary ? 0.25 : 0.2

    return `linear-gradient(135deg, rgba(${r}, ${g}, ${b}, ${opacity1}) 0%, rgba(${r}, ${g}, ${b}, ${opacity2}) 100%)`
  }};

  ${({ $isPrimary, $color }) =>
    $isPrimary &&
    css`
      border: 1px solid
        ${(() => {
          if (!$color || $color.trim() === '') return '#d1d5db'
          const hex = $color.replace('#', '')
          const r = parseInt(hex.substr(0, 2), 16)
          const g = parseInt(hex.substr(2, 2), 16)
          const b = parseInt(hex.substr(4, 2), 16)
          return `rgba(${r}, ${g}, ${b}, 0.3)`
        })()};
    `}

  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background: ${({ $color, $isPrimary }) => {
      if (!$color || $color.trim() === '') return '#d1d5db'

      const hex = $color.replace('#', '')
      const r = parseInt(hex.substr(0, 2), 16)
      const g = parseInt(hex.substr(2, 2), 16)
      const b = parseInt(hex.substr(4, 2), 16)

      const opacity1 = $isPrimary ? 0.2 : 0.15
      const opacity2 = $isPrimary ? 0.3 : 0.25

      return `linear-gradient(135deg, rgba(${r}, ${g}, ${b}, ${opacity1}) 0%, rgba(${r}, ${g}, ${b}, ${opacity2}) 100%)`
    }};
  }
`

export const PrimaryIndicator = styled.span`
  font-size: 10px;
  color: inherit;
  opacity: 0.8;
  margin-left: 2px;
`

export const AddTagButton = styled.button.attrs({ type: 'button' })`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  height: 24px;
  gap: 4px;
  margin: 0;
  padding: 0 10px;
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  line-height: 1;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.border.focus};
    outline-offset: 2px;
  }
`

export const PlusIcon = styled.svg`
  width: 12px;
  height: 12px;
  stroke-width: 2;
`
